/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Goods } from './Goods';
import {
    GoodsFromJSON,
    GoodsFromJSONTyped,
    GoodsToJSON,
    GoodsToJSONTyped,
} from './Goods';

/**
 * 
 * @export
 * @interface KoreaReturnApplicationOrderVo
 */
export interface KoreaReturnApplicationOrderVo {
    /**
     * 
     * @type {number}
     * @memberof KoreaReturnApplicationOrderVo
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KoreaReturnApplicationOrderVo
     */
    orderCode?: string;
    /**
     * 
     * @type {number}
     * @memberof KoreaReturnApplicationOrderVo
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof KoreaReturnApplicationOrderVo
     */
    memberName?: string;
    /**
     * 
     * @type {string}
     * @memberof KoreaReturnApplicationOrderVo
     */
    memberCode?: string;
    /**
     * 
     * @type {number}
     * @memberof KoreaReturnApplicationOrderVo
     */
    koreaWarehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof KoreaReturnApplicationOrderVo
     */
    koreaOutboundDate?: string;
    /**
     * 
     * @type {string}
     * @memberof KoreaReturnApplicationOrderVo
     */
    coupangInboundCode?: string;
    /**
     * 
     * @type {Array<Goods>}
     * @memberof KoreaReturnApplicationOrderVo
     */
    goodsList?: Array<Goods>;
}

/**
 * Check if a given object implements the KoreaReturnApplicationOrderVo interface.
 */
export function instanceOfKoreaReturnApplicationOrderVo(value: object): value is KoreaReturnApplicationOrderVo {
    return true;
}

export function KoreaReturnApplicationOrderVoFromJSON(json: any): KoreaReturnApplicationOrderVo {
    return KoreaReturnApplicationOrderVoFromJSONTyped(json, false);
}

export function KoreaReturnApplicationOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaReturnApplicationOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'memberName': json['memberName'] == null ? undefined : json['memberName'],
        'memberCode': json['memberCode'] == null ? undefined : json['memberCode'],
        'koreaWarehouseId': json['koreaWarehouseId'] == null ? undefined : json['koreaWarehouseId'],
        'koreaOutboundDate': json['koreaOutboundDate'] == null ? undefined : json['koreaOutboundDate'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(GoodsFromJSON)),
    };
}

export function KoreaReturnApplicationOrderVoToJSON(json: any): KoreaReturnApplicationOrderVo {
    return KoreaReturnApplicationOrderVoToJSONTyped(json, false);
}

export function KoreaReturnApplicationOrderVoToJSONTyped(value?: KoreaReturnApplicationOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderCode': value['orderCode'],
        'userId': value['userId'],
        'memberName': value['memberName'],
        'memberCode': value['memberCode'],
        'koreaWarehouseId': value['koreaWarehouseId'],
        'koreaOutboundDate': value['koreaOutboundDate'],
        'coupangInboundCode': value['coupangInboundCode'],
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(GoodsToJSON)),
    };
}

